module.exports = __webpack_public_path__ + "static/media/Asswssment-lrg.adfe78de.svg";